module.exports = __webpack_public_path__ + "static/assets/0288afb0be1ab93b1160026b13c8eb22.png";